import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
//import Box from "@material-ui/core/Box";
import DialogContent from "@material-ui/core/DialogContent";
import Paper from "@material-ui/core/Paper";

import { Formik } from "formik";
import TextField from "@material-ui/core/TextField";

import FormControl from "@mui/material/FormControl";
//import FormControlLabel from "@mui/material/FormControlLabel";

import {
    makeStyles,
    ThemeProvider,
    createMuiTheme,
} from "@material-ui/core/styles";

import {
    DataGrid,
    ptBR,
    GridToolbarContainer,
    GridFilterToolbarButton,
} from "@material-ui/data-grid";


import CloseIcon from "@material-ui/icons/Close";

import {
    getClienteLocal,
    insertClienteLocal,
    updateClienteLocal,
    deleteClienteLocal
} from "../../../services/ClienteLocalService";

import {
    ButtonCancel,
    ButtonDelete,
    ButtonSave
} from "../../botoes/operacao";

import { Loading } from "../../Loading";
import { ShowMessageBox } from "../../ShowMessageBox";

const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        marginLeft: "2rem",
        alignItems: "center",

        height: "75vh",
        width: "95%",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        backgroundColor: "white",
        height: "90%",
        width: "90%",
        //'border': '5px solid blue',
        display: "flex",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        height: "90%",
        width: "450px",
        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#D6EAF8",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#AED6F1",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",

            color: "white",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#D3D3D3",
            color: "black",
        },
    },
    side_content: {
        /*        'background-color': '#cce0ff',*/
        /*        'border': 'solid 1px #0052cc',*/
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        paddingTop: "100px",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

let severity = "success";
let msg = "";
let inserir = true;

const theme = createMuiTheme(
    ptBR
);

export default function DialogoLocalidade({ isOpened, closeDialog, cliente }) {
    const classes = useStyles();
    const [clienteLocal, setClienteLocal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackBar, setSnackBar] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState({ loc_nome: "" });

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridFilterToolbarButton />
            </GridToolbarContainer>
        );
    };

    useEffect(async () => {
        setLoading(true);
        try {
            const respClienteLocal = await getClienteLocal(cliente.cli_id);
            setClienteLocal(respClienteLocal.data);
        } catch (error) {
            setClienteLocal([]);
        }
        inserir = true;
        setLoading(false);
    }, []);


    const deleteRecord = async () => {
        setLoading(true);
        try {
            await deleteClienteLocal(selectedRow.loc_id);
            const respCliente = await getClienteLocal(cliente.cli_id);
            setClienteLocal(respCliente.data);
            msg = "Localidade excluída com sucesso";
            severity = "success";
            setSnackBar(true);
            setLoading(false);
            cancelRecord();
        } catch (error) {
            msg = "Erro ao excluir localidade";
            severity = "error";
            setSnackBar(true);
            setLoading(false);
        }
    }

    const cancelRecord = () => {
        setSelectedRow({ loc_nome: "" });
        inserir = true;
    }

    return (
        <Dialog
            open={isOpened}
            aria-labelledby="form-dialog-title"
            fullWidth
            maxWidth="lg"
            style={{ zIndex: 1000 }}
        >
            <div
                id="form-dialog-title"
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingRight: "2rem",
                    paddingLeft: "2rem",
                    alignItems: "center",
                    background: "lightblue",
                    height: "4rem",
                }}
            >
                <span style={{ fontSize: "1.2rem" }}>
                    Cliente: <b>{cliente.cli_nome}</b>
                </span>
                <ButtonCancel
                    variant="contained"
                    color="primary"
                    type="button"
                    style={{
                        padding: "3px",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    onClick={closeDialog}
                >
                    <CloseIcon />
                </ButtonCancel>

            </div>

            <DialogContent>
                <Loading open={loading} />
                <ShowMessageBox
                    open={snackBar}
                    setOpen={setSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div style={{ flexGrow: 1, padding: '10px' }}>
                            <div className={classes.boxDataGrid}>
                                <ThemeProvider theme={theme}>
                                    <DataGrid
                                        rows={clienteLocal}
                                        disableColumnMenu
                                        disableColumnReorder
                                        id="loc_id"
                                        spacing={0}
                                        direction="column"
                                        headerAlign="center"
                                        rowHeight={50}
                                        pageSize={15}
                                        onRowSelected={(newSelection) => {
                                            setSelectedRow(newSelection.data);
                                            inserir = false;
                                        }}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                        columns={[
                                            {
                                                field: "loc_nome",
                                                headerName: "Localidade",
                                                headerClassName: "header_grid",
                                                align: "center",
                                                type: "string",
                                                headerAlign: "center",
                                                flex: 1,
                                                sortable: false,
                                            }
                                        ]}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                        <div style={{ flexGrow: 1, flexDirection: 'column', alignSelf: 'center', padding: '10px' }}>
                            <Formik
                                initialValues={{
                                    locNome: selectedRow.loc_nome,
                                }}
                                enableReinitialize
                                validate={(values) => {
                                    const errors = {};
                                    if (!values.locNome) {
                                        errors.locNome = "Obrigatório";
                                    }
                                    return errors;
                                }}
                                onSubmit={async (values, { setSubmitting }) => {
                                    setSubmitting(true);
                                    setLoading(true);
                                    if (inserir) {
                                        try {
                                            await insertClienteLocal({
                                                loc_nome: values.locNome,
                                                cli_id: cliente.cli_id
                                            });

                                            const respCliente = await getClienteLocal(cliente.cli_id);
                                            setClienteLocal(respCliente.data);
                                            msg = "Localidade incluido com sucesso";
                                            severity = "success";
                                            setLoading(false);
                                            setSnackBar(true);
                                            cancelRecord();
                                        } catch (error) {
                                            msg = "Erro ao inserir localidade";
                                            severity = "error";
                                            setSnackBar(true);
                                            setLoading(false);
                                        }
                                    } else {
                                        try {
                                            const updateData = {
                                                loc_nome: values.locNome,
                                            };

                                            await updateClienteLocal(selectedRow.loc_id, updateData);

                                            const respCliente = await getClienteLocal(cliente.cli_id);
                                            setClienteLocal(respCliente.data);
                                            msg = "Localidade atualizado com sucesso";
                                            severity = "success";
                                            setSnackBar(true);
                                            setLoading(false);
                                            cancelRecord();
                                        } catch (error) {
                                            msg = "Erro ao atualizar localidade";
                                            severity = "error";
                                            console.log(error);
                                            setSnackBar(true);
                                            setLoading(false);
                                        }
                                    }
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    isValid,
                                }) => (
                                    <form onSubmit={handleSubmit} className={classes.form}>
                                        <div className={classes.input_data}>
                                            <FormControl>
                                                <TextField
                                                    value={values.locNome}
                                                    id="locNome"
                                                    name="locNome"
                                                    inputProps={{ maxLength: 50 }}
                                                    type="text"
                                                    required
                                                    onChange={handleChange}
                                                    label="Localidade"
                                                    helperText={errors.locNome}
                                                    variant="outlined"
                                                />
                                            </FormControl>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "flex-end",
                                                    marginTop: "1rem",
                                                }}
                                            >
                                                <ButtonSave
                                                    variant="contained"
                                                    size="small"
                                                    color="primary"
                                                    type="submit"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    disabled={!isValid}
                                                >
                                                    Salvar
                                                </ButtonSave>
                                                <ButtonCancel
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={cancelRecord}
                                                    disabled={inserir}
                                                >
                                                    Cancelar
                                                </ButtonCancel>

                                                <ButtonDelete
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={deleteRecord}
                                                    disabled={inserir}
                                                >
                                                    Excluir
                                                </ButtonDelete>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </Paper>
                </div>
            </DialogContent >
        </Dialog >
    );
};

